import { buildPath } from "../../../helpers/string";
import { root } from "./root";

export const messages = {
  path: "messages",
  getLink: () => buildPath([root.path, messages.path]),
  permissions: [],
  inbox: {
    path: "inbox",
    getLink: () => buildPath([messages.getLink(), messages.inbox.path]),
    permissions: [],
    conversation: {
      path: "conversation",
      getLink: () => buildPath([messages.inbox.getLink(), messages.inbox.conversation.path]),
      permissions: [],
      details: {
        path: ":conversationId",
        getLink: (conversationId: string | number) =>
          buildPath([messages.inbox.conversation.getLink(), conversationId.toString()]),
        permissions: [],
      },
    },
  },
  favorites: {
    path: "favorites",
    getLink: () => buildPath([messages.getLink(), messages.favorites.path]),
    permissions: [],
    conversation: {
      path: "conversation",
      getLink: () => buildPath([messages.favorites.getLink(), messages.favorites.conversation.path]),
      permissions: [],
      details: {
        path: ":conversationId",
        getLink: (conversationId: string | number) =>
          buildPath([messages.favorites.conversation.getLink(), conversationId.toString()]),
        permissions: [],
      },
    },
  },
  trash: {
    path: "trash",
    getLink: () => buildPath([messages.getLink(), messages.trash.path]),
    permissions: [],
    conversation: {
      path: "conversation",
      getLink: () => buildPath([messages.trash.getLink(), messages.trash.conversation.path]),
      permissions: [],
      details: {
        path: ":conversationId",
        getLink: (conversationId: string | number) =>
          buildPath([messages.trash.conversation.getLink(), conversationId.toString()]),
        permissions: [],
      },
    },
  },
  folder: {
    path: "folder",
    getLink: () => buildPath([messages.getLink(), messages.folder.path]),
    permissions: [],
    details: {
      path: ":folderId",
      getLink: (folderId: string | number) => buildPath([messages.folder.getLink(), folderId.toString()]),
      permissions: [],
      conversation: {
        path: "conversation",
        getLink: (folderId: string | number) =>
          buildPath([messages.folder.details.getLink(folderId), messages.folder.details.conversation.path]),
        permissions: [],
        details: {
          path: ":conversationId",
          getLink: (folderId: string | number, conversationId: string | number) =>
            buildPath([messages.folder.details.conversation.getLink(folderId), conversationId.toString()]),
          permissions: [],
        },
      },
    },
  },
};
